import Vue from 'vue';
import {BootstrapVue, IconsPlugin} from "bootstrap-vue";
import vSelect from 'vue-select';
import MainLayout from '@/components/Nav/MainLayout'

//Font Awesome
import {dom, library} from '@fortawesome/fontawesome-svg-core'
import {faEdit, faSave} from '@fortawesome/free-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
//CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.css'
import 'vue-select/dist/vue-select.css';
//App
import router from './router'
import App from "@/App";

library.add(faSave, faEdit);
dom.watch();

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('v-select', vSelect);

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.component(MainLayout.name, MainLayout)

Vue.config.productionTip = false

new Vue({
  router,
  el: "#app",
  render(h) {
    return h(App)
  }
})
